// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"4cf28736","919":"02c80140"}[chunkId] + ".chunk.js";
};